import { BACKSPACE } from '@angular/cdk/keycodes';
import { Component, Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, ValidatorFn, Validators } from '@angular/forms';
import STUDIO_TABS from '../../../assets/data/studio-tab.json';

@Injectable({
  providedIn: 'root'
})
export class FormsService {
  public textTypeField:boolean = false;
  public textConfirmTypeField:boolean = false;
  public textCurrentTypeField:boolean = false;
  public studioSettingList: Array<any> = [];
  public currentDate: Date = new Date(new Date().setHours(0, 0, 0, 0));;
  constructor() {
    this.studioSettingList = STUDIO_TABS;
   }


  /**
   * use as callback to an input (input) event
   * @param control 
   */
  preventSpaces(control: AbstractControl) {
    control.setValue(control.value.replace(/\s/g, ''));
  }


  /**
   * use as callback to an input (change) event
   * @param control 
   */
  trimSpaces(control: AbstractControl) {
    control.setValue(control.value.trim());
  }

  /**
    * in  this function we returning form control
    * according to its type 
    * @param type 
    */
getFormControl(type: any, value?: any, min: number = 500, max: number = 10000000): FormControl {
    switch (type) {
        case 'email': 
          return new FormControl('', [Validators.required,Validators.email]);
        case 'name':
          return  new FormControl('', [Validators.required, this.emptyValueCheck()]);
        case 'name-without-emoji':
          return  new FormControl('', [Validators.required, this.validateEmoji(), this.emptyValueCheck()]);
        case 'name-without-emoji-without-validation':
          return  new FormControl('', [this.validateEmoji()]);
        case 'confirm-password':
          return  new FormControl('', [Validators.required,Validators.minLength(8),this.validatePassword(), this.emptyValueCheck()]);
        case 'password':
          return new FormControl('', [Validators.required,Validators.minLength(8), this.emptyValueCheck() ]);
        case 'password-login':
          return new FormControl('', [Validators.required, this.emptyValueCheck()]);
        case 'mobileNumber':
          return new FormControl('', [Validators.required,Validators.minLength(10), this.emptyValueCheck(), this.numberNotStartWithZeroValidator()]);
        case 'beatTempo':
          return new FormControl('', [Validators.required, this.minMaxValidator(10,500) ]);
        case 'regularPrice':
          return new FormControl('', [Validators.required,this.minMaxValidator(500,'') ]);
        case 'regularPriceSound':
          return new FormControl('', [Validators.required,this.minMaxValidator(500, 10000000) ]);
        case 'discountPrice':
          return new FormControl('', [Validators.required]);
        case 'account-number':
          return new FormControl('', [Validators.required,this.minMaxValidator(10,50), this.emptyValueCheck() ]);
        case 'link':
          return new FormControl('', [Validators.required,Validators.pattern(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) ]);
        case 'instalink':
          return new FormControl('', [Validators.pattern(/^(https?:\/\/)?(www\.)?instagram\.com\/reel\/[A-Za-z0-9_-]+\/?(?:\?.*)?$/)]);
        case 'instalinkRequired':
          return new FormControl(value, [Validators.required,Validators.pattern(/^(https?:\/\/)?(www\.)?instagram\.com\/reel\/[A-Za-z0-9_-]+\/?(?:\?.*)?$/) ]);
        case 'link-without-validation':
          return new FormControl('', [Validators.pattern(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) ]);
        case 'embeddedCode':
          return new FormControl('', [Validators.pattern(/^.*(open.spotify.com\/+embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/) ]);
        case 'finalPrice':
          return new FormControl('0.00₹', [Validators.required ]);
        case 'without-validate':
          return new FormControl('');
        case 'store-handle':
           return new FormControl(value, [Validators.required, this.emptyValueCheck(), this.storeHandleValueCheck()])
        case 'element-count':
           return new FormControl(value, [Validators.required, this.emptyValueCheck(), this.minMaxValidator(1,100000)])
        case 'initialValue':
          return new FormControl(value);
        case 'startDate':
          return new FormControl(this.currentDate, [Validators.required]);
        case 'endDate':
          return new FormControl(value, [this.endDateValidator()]);
        case 'campaignName':
          return new FormControl(value, [Validators.required, Validators.maxLength(100)]);
        case 'number':
          return new FormControl(value, [Validators.required, this.minMaxValidator(min, max)]);
        case 'costPerImpression':
          return new FormControl(value);
        default: 
          return new FormControl(value, [Validators.required, this.emptyValueCheck()])
    }
  }

  /**
   * common Error Message for input Fields
   * @param field : AbstractControl
   * @returns string value 
   */
  getErrorMessage(field: AbstractControl, type: string = 'password', min: number = 6, max: number = 8) {
    if (!field.touched) {
      return '';
    }
    if (field.hasError('required')) {
      return `This field is required`;
    } else if (field.hasError('email')) {
      return `Must be a valid email address`;
    } else if (field.hasError('minlength') && type !== 'Whatsapp Mobile Number') {
      return `${type} must be of at least ${min} characters`;
    } else if (field.hasError('minlength') && type === 'Whatsapp Mobile Number') {
      return `Minimum ${min} digits are required`;
    } else if (field.hasError('maxlength')) {
      return `${type} must be of at least ${max} characters.`;
    } else if (field.hasError('validateEqual')) {
      return ` Passwords must match`
    } else if (field.hasError('notZero')) {
      return ` A number should not start with zero`
    } else if (field.hasError('pattern')) {
      return ` Passwords must be at least one letter, one number and one special character`;
    } else if (field.hasError('min') && type !== 'License fee') {
      return `${type} must be min value ${min}`;
    } else if (field.hasError('min') && type === 'License Period') {
      return `Min. Period: ${min} years`;
    }  else if (field.hasError('min') && type === 'License fee') {
      return `${type} should be of atleast ₹${min}`;
    } else if (field.hasError('max') && type !== 'License fee') {
      return `${type} should be maximum ${max}`
    } else if (field.hasError('max') && type === 'License fee') {
      return `${type} can be maximum ₹${max}`
    } else if (field.hasError('emojiError')) {
      return `Only alphabets, numbers, and characters are allowed.`;
    } else if(field.hasError('dateInPast') && field.hasError('endIsToday')) {
      return `Date cannot be in the past`;
    } else if(field.hasError('endBeforeStart')) {
      return `End date & time must be after the start date & time`;
    }
    return '';
  }

  /**
   * Return Link Pattern Message
   * @param field 
   * @returns 
   */
  getLinkPatternMessage(field: AbstractControl, messaageType: string = "") {
    if (field.hasError('required')) {
      return `This field is required`;
    } else if(field.hasError('pattern')) {
      return `Please enter correct link. For eg - https://abcd.com`;
    } else if (field.hasError('storeHandleWrong')) {
      return `Store handle cannot contain '${field.value}'.`;
    } else {
      return '';
    }
  }

  /**
   * Return embedded code Pattern Message
   * @param field 
   * @returns 
   */
  getEmbedPatternMessage(field: AbstractControl) {
    if (field.hasError('required')) {
      return `This field is required`;
    } else if(field.hasError('pattern')) {
      return `Please enter correct link. For eg - https://open.spotify.com/embed/album/asjhdahsduh`;
    } else {
      return '';
    }
  }

  /**
 * Only Number Enter 
 * @param event 
 */
 /* istanbul ignore next */
  keyPressNumber(event: any) {
    const pattern = /[0-9]/;
    if (event?.type === 'keypress') {
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != BACKSPACE && !pattern.test(inputChar)){
        event.preventDefault();
        return false;
      }
    } else {
      if (event && !pattern.test(event.target?.value)) {
        event.preventDefault();
        event.target.value = '';
        return false;
      }
    }
   return true;
  }

  setControlValue(field: AbstractControl) {
      field.setValue('');
  }

  /**
 * Only Character Enter 
 * @param event 
 */
 /* istanbul ignore next */
  keyPressCharacter(event: any) {
    const pattern = /^[a-zA-Z\s]*$/g;
    if (event?.type === 'keypress') {
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != BACKSPACE && !pattern.test(inputChar)){
        event.preventDefault();
        return false;
      }
    } else {
      if (!pattern.test(event.target.value)) {
        event.preventDefault();
        event.target.value = '';
        return false;
      }
    }
    return true;
  }

  /**
 * Only Character Enter 
 * @param event 
 */
 /* istanbul ignore next */
  keyNumberOnlyTwoDecimal(event: any) {
    const pattern = /^[a-zA-Z\s]*$/g;
    if (event?.type === 'keypress') {
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != BACKSPACE && !pattern.test(inputChar)){
        event.preventDefault();
        return false;
      }
    } else {
      if (!pattern.test(event.target.value)) {
        event.preventDefault();
        event.target.value = '';
        return false;
      }
    }
    return true;
  }

  /**
 * Only Character and number Enter 
 * @param event 
 */
 /* istanbul ignore next */
  keyPressAlphaNumericValues(event: any) {
    const pattern = /^([A-Za-z\s]|[0-9]|_)+$/g;
    if (event?.type === 'keypress') {
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != BACKSPACE && !pattern.test(inputChar)){
        event.preventDefault();
        return false;
      }
    } else {
      if (!pattern.test(event.target.value)) {
        event.preventDefault();
        event.target.value = '';
        return false;
      }
    }
    return true;
  }


  //Show Hide Password Function  

  showHidePassword(type: string = "") {
    if (type && type === 'CP') {
      this.textConfirmTypeField = !this.textConfirmTypeField;
    } else if (type &&  type ===  'currentPassword') {
      this.textCurrentTypeField = !this.textCurrentTypeField;
    } else  {
      this.textTypeField = !this.textTypeField;
    }
  }

  /**
   * in this function we are checking confirm password 
   * is match  with password  
   */
  validatePassword(): ValidatorFn {
    return (c: AbstractControl): { [key: string]: any } => {
      let v = c.value;
      let e = c.root.get('password');
      if (e &&  v !== e.value)
        return {
          validateEqual: v
        }
      return {};
    }
  }

    /**
   * in this function we are checking emoji validation
   */
    validateEmoji(): ValidatorFn {
      return (c: AbstractControl): { [key: string]: any } | null => {
        let value = c.value;
        if (!value) {
          return null;
        }
        const pattern = /^([A-Za-z\s]|[0-9]|_)+$/g;
        if (!pattern.test(value)) {
          return {
            'emojiError': value
          }
        }
        return null;
      }
    }

  dateNotBeforeTodayValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const selectedDate = new Date(value);
       selectedDate.setHours(0, 0, 0, 0);
      return selectedDate < this.currentDate ? { dateInPast: true } : null;
    };
  }

  endDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const endValue = control.value;
      if (!endValue) {
        return null;
      }
      const parent = control.parent;
      if (!parent) {
        return null;
      }
      const startValue = parent.get('startDate')?.value;
      if (!startValue) {
        return null;
      }
      const startDate = new Date(startValue);
      const endDate = new Date(endValue);
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return null;
      }

      // The schedule now carries a time component, so compare the full
      // timestamps instead of flattening both to day boundaries. This is what
      // enforces "end must be later than start" when both fall on the same day.
      if (endDate.getTime() <= startDate.getTime()) {
        return { endBeforeStart: true };
      }
      // if (endDate.getTime() === this.currentDate.getTime()) {
      //   return { endIsToday: true };
      // }
      return null;
    };
  }

    /**
   * in this function we are checking emoji validation
   */
      emptyValueCheck(): ValidatorFn {
      return (c: AbstractControl): { [key: string]: any } | null => {
        let value = c.value;
        if (typeof(value) === 'string') {
          value = value.trim();
        }
        if (typeof(value) === 'string' && value.length === 0) {
          return {
            'required': true
          }
        } else {
          return  null;
        }
      }
    }

  /**
   * Custom validator min and max value 
   * @param min Number
   * @param max Number
   * @returns 
   */
  minMaxValidator(min: any, max: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let value = control.value;
      if (!value) {
        return null;
      }

      if (parseInt(value) < min) {
        return { 'min': true };
      }
      if (max) {
        if (parseInt(value) > max) {
          return { 'max': true };
        }
      }
      return null;
    }
  }

  /**
   * Not start with zero 
   * @returns 
   */
  numberNotStartWithZeroValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let value = control.value;
      if (!value) {
        return null;
      }
      let regex: RegExp = /^[1-9][0-9]*$/
      if (!regex.test(value)) {
        return { 'notZero': true };
      }
      return null;
    }
  }

  prepareLicenseControl() {
    let data = [
      {
        "key": "id",
        "controlType": "without-validate"
      },
      {
        "key": "regularPrice",
        "controlType": "regularPrice"
      },
      {
        "key": "finalPrice",
        "controlType": "finalPrice"
      },
      {
        "key": "publishingRights",
        "controlType": ""
      },
      {
        "key": "negotiationAllow",
        "controlType": "without-validate",
        "type": 'negotiation'
      },
      {
        "key": "licensePeriod",
        "controlType": ""
      },
      {
        "key": "masterRecording",
        "controlType": ""
      }
    ];
    return data;
  }

  calculateProgress(progressCircle:string, progressBar:string, progressVal:string, formName:any, id: any = "", billingAddress: any = "") {
    let circularProgress:any = document.querySelector(progressCircle);
    let barProgress:any = document.querySelector(progressBar);
    let progressValue:any = document.querySelector(progressVal);
    let totalControls = 0;
     let totalProgress = 0;
    if (id !== "accbnk") {
      totalControls = Object.keys(formName.controls).length;
    }
    if (id === "accbnk") {
      totalControls += 1;
    }
    for (const controlName in formName.controls) {
      if (formName.controls.hasOwnProperty(controlName)) {
        if (id === "accbnk") {
          if (formName.controls[controlName].hasValidator(Validators.required)) {
            totalControls += 1;
            totalProgress += formName.controls[controlName].value ? 1 : 0;
          }
        } else {
          totalProgress += formName.controls[controlName].value ? 1 : 0;
        }
      }
    }
    if (id === "accbnk" && billingAddress.length > 0) {
      totalProgress += 1;
    }
    let progressBarValue = Math.round( (totalProgress / totalControls) * 100);
    progressValue.textContent = progressBarValue + '%';
    let deg = '#7000FF,#8F00FF '+ (progressBarValue * 3.6)+'deg, #222222 0deg'
    circularProgress.style.background = `conic-gradient(${deg})`;
    barProgress.style.width = progressBarValue +'%';
    this.studioSettingList = this.studioSettingList.filter((studio: any) => {
      if (studio?.id === id) {
        studio.totalProgress = progressBarValue }
      return studio;
    });
  }

   /**
   * in this function we are checking store Handle validation
   */
    storeHandleValueCheck(): ValidatorFn {
      return (c: AbstractControl): { [key: string]: any } | null => {
        let value = c.value;
        if (typeof(value) === 'string') {
          value = value.trim();
        }

        let restrictedStoreHandleList:Array<any> = ["beat22", "beat", "beatbhai", "illpeoplemusic"];
        // check if value contains any restricted word
        if (value) {
          const isRestricted = restrictedStoreHandleList.some(item =>  value.includes(item));
          if (isRestricted) {
            return {
              'storeHandleWrong': true
            }
          }
        }
        return  null;
      }
    }

  minItemsValidator(min: number) {
    return (formArray: FormArray) => {
      return formArray.length >= min ? null : { minItems: true };
    };
  }   
}
